import { render, staticRenderFns } from "./sendEmailConfirmation.vue?vue&type=template&id=1ba3d259&scoped=true&"
import script from "./sendEmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./sendEmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./sendEmailConfirmation.vue?vue&type=style&index=0&id=1ba3d259&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3d259",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VLayout,VProgressCircular})
